import { db } from "../../utils/firebase";

// get all projects
export const getAllProjects = async () => {
  const querySnapshot = await db
    .collection("projects")
    .orderBy("title", "asc")
    .get();

  const data = { current: [], past: [] };
  querySnapshot.forEach((doc) => {
    let { id, title, isCurrent, externalLink, hidden, content, thumbnail, images } = doc.data()
    if (hidden) {
      return;
    }
    if (isCurrent) {
      if (externalLink) {
        if (!thumbnail && images) {
          thumbnail = images[0];
        }
        data.current.push({ title, id, externalLink, thumbnail });
      } else { //not an external link; has a description
        let summary = content.replaceAll(/<.*?>/g, '').substring(0, 300) + "...";
        if (!thumbnail && images) {
          thumbnail = images[0];
        }
        

        data.current.push({ id, title, summary, thumbnail });
      }
    } else {
      if (externalLink) {
        data.past.push({ externalLink, title });
      } else {
        data.past.push({ id, title });
      }
    }
  });

  return data;
};

// get single project by id
export const getProjectById = async (id) => {
  const querySnapshot = await db
    .collection("projects")
    .where("id", "==", id)
    .get();

  const data = {
    title: "",
    content: "",
    images: [],
    imageCaptions: [],
    publications: [],
    support: "",
    people: [],
    pastPeople: [],
    relatedProjects: [],
    relatedPastProjects: [],
    posters: [],
    videos: [],
    videoCaptions: [],
    participantRecruting: "",
    awards: []
  };
  if (querySnapshot.docs.length === 1) {
    querySnapshot.forEach((doc) => {
      const {
        title,
        content,
        images,
        imageCaptions,
        publications,
        support,
        people,
        pastPeople,
        relatedProjects,
        relatedPastProjects,
        posters,
        videos,
        videoCaptions,
        participantRecruting,
        awards
      } = doc.data();

      if (title) data.title = title;
      if (content) data.content = content;
      if (support) data.support = support;
      if (images) data.images = images;
      if (imageCaptions) data.imageCaptions = imageCaptions;
      if (publications) data.publications = publications;
      if (people) data.people = people;
      if (pastPeople) data.pastPeople = pastPeople;
      if (relatedProjects) data.relatedProjects = relatedProjects;
      if (relatedPastProjects) data.relatedPastProjects = relatedPastProjects;
      if (posters) data.posters = posters;
      if (videos) data.videos = videos;
      if (videoCaptions) data.videoCaptions = videoCaptions;
      if (participantRecruting) data.participantRecruting = participantRecruting;
      if (awards) data.awards = awards;
    });
  }

  return data;
};

// get project lists content
export const getProjectListsContent = async (url, id) => {
  const contentDB = db.collection(url);

  const data = { title: "", content: "" };
  const querySnapshot = await contentDB.where("id", "==", id).get();
  if (querySnapshot.docs.length === 1) {
    querySnapshot.forEach((doc) => {
      const { title, content } = doc.data();
      data.title = title;
      data.content = content;
    });
  }

  return data;
};

// get project lists
export const getProjectLists = async (url, key) => {
  const querySnapshot = await db
    .collection("projects")
    .orderBy("title", "asc")
    .get();

  const data = { projects: [], pastProjects: [] };
  querySnapshot.forEach((doc) => {
    let { areas, domains, id, title, isCurrent, externalLink, content, thumbnail, images } = doc.data()
    // for areas page
    if (url === "areas") {
      if (!areas) areas = [];
      const inArea = areas.some((area) => area === key);
      if (inArea) {
        if (isCurrent) {
          let summary = content.replaceAll(/<.*?>/g, '').substring(0, 300) + "...";
          if (!thumbnail && images) {
            thumbnail = images[0];
          }
          data.projects.push({ id, title, summary, thumbnail });
        } else {
          if (externalLink) {
            data.pastProjects.push({ externalLink, title });
          } else {
            data.pastProjects.push({ id, title });
          }
        }
      }
    } else if (url === "domains") {
      // for domains page
      if (!domains) domains = [];
      const inDomain = domains.some((domain) => domain === key);
      if (inDomain) {
        if (isCurrent) {
          let summary = content.replaceAll(/<.*?>/g, '').substring(0, 300) + "...";
          if (!thumbnail && images) {
            thumbnail = images[0];
          }
          data.projects.push({ id, title, summary, thumbnail });
        } else {
          if (externalLink) {
            data.pastProjects.push({ externalLink, title });
          } else {
            data.pastProjects.push({ id, title });
          }
        }
      }
    }
  });

  return data;
};
